export const ATTRIBUTES = {
  EMAIL_CONFIRMED: "email_confirmed",
  GA_COOKIE: "ga_cookie",
  EMAIL_VERIFICATION_SKIPPED: "email_verification_skipped",
  ACCEPT_ANCESTRY_RESULTS: "accept_ancestry_results",
};
